<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useCollectionFiltersStore} from '@/stores/collectionFilters'
import {useComponentStructureStore} from '@/stores/componentStructure'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    contentId: Number,
    item: Object
})

const componentsStore = useComponentsStore()
const collectionFiltersStore = useCollectionFiltersStore()
const componentStructureStore = useComponentStructureStore()
const itemDataStore = useItemDataStore()

const content = ref(null)

watch(
    () => props.contentId,
    async (newId) => {
        if (!newId) {
            content.value = null
            return
        }
        content.value = await itemDataStore.get({
            tableName: 'content',
            id: newId
        })
    },
    {immediate: true}
)

const contentType = ref(null)

watch(
    content,
    async (newContent) => {
        if (!newContent) {
            contentType.value = null
            return
        }
        contentType.value = await itemDataStore.get({
            tableName: 'templates_templates',
            id: newContent.contentType
        })
    },
    {immediate: true}
)

const componentId = computed(() => contentType.value?.componentId)
const component = computed(() => componentsStore.items.find(o => o.id === componentId.value))

const fields = computed(() => {
    if (!componentId.value) return []
    const structure = componentStructureStore.get(componentId.value)
    if (!structure) return []

    return structure
        .slice()
        .sort((a, b) => (a.title > b.title ? 1 : -1))
        .filter((o) => {
            const options = collectionFiltersStore.typesOptions(o.type, props.item.fieldId)
            return options.length > 0
        })
})
</script>

<template>
    <select v-model.number="item.fieldId" class="form-select form-select-sm d-inline-block w-auto">
        <option :value="null">{{ component?.title }} items</option>
        <option disabled>──────────</option>
        <option v-for="field in fields" :key="field.id" :value="field.id">
            {{ field.title }}
        </option>
    </select>
</template>